import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch, jsonHeaders } from "../api/api";
import logo from "../logo.png";
import passwordRevealed from "../assets/password_revealed.png";
import passwordNotRevealed from "../assets/password_not_revealed.png";

const iconStyle = { width: 24, height: 24, verticalAlign: "middle" };
const checkStyle = { color: "#22c55e", marginRight: 6, fontWeight: "bold" };
const crossStyle = { color: "#ef4444", marginRight: 6, fontWeight: "bold" };

function getCriteria(password) {
  return {
    length: password.length >= 12,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };
}

export default function ChangePassword() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", currentPassword: "", newPassword: "", confirmNew: "" });
  const [showCurr, setShowCurr] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const criteria = useMemo(() => getCriteria(form.newPassword), [form.newPassword]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  // After success, send user back to Login after a brief delay
  useEffect(() => {
    if (!success) return;
    const t = setTimeout(() => navigate("/login"), 3000);
    return () => clearTimeout(t);
  }, [success, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    setSuccess("");
    // Validate strength and match
    if (!(criteria.length && criteria.upper && criteria.lower && criteria.number && criteria.special)) {
      setError("Password must be at least 12 characters and include uppercase, lowercase, number, and special character.");
      setSubmitting(false);
      return;
    }
    if (form.newPassword !== form.confirmNew) {
      setError("Passwords do not match");
      setSubmitting(false);
      return;
    }
    try {
      await apiFetch(`/change-password`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({
          email: form.email,
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        }),
      });
  setSuccess("Password updated. Redirecting to login…");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      style={{ minHeight: "80vh", display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: 32, marginBottom: 32 }}>
        <img src={logo} alt="Counselor Notes Logo" style={{ width: 400, maxWidth: "90vw" }} />
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "40vh", width: 320 }}>
        <h1 style={{ textAlign: "center" }}>Change Password</h1>
        <form style={{ width: "100%", display: "flex", flexDirection: "column", gap: 20, marginTop: 32 }} onSubmit={handleSubmit}>
          <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} style={{ padding: 12, fontSize: 16, borderRadius: 4, border: "1px solid #ccc" }} required />

          <div style={{ position: "relative" }}>
            <input name="currentPassword" type={showCurr ? "text" : "password"} placeholder="Current Password" value={form.currentPassword} onChange={handleChange} style={{ padding: 12, fontSize: 16, borderRadius: 4, border: "1px solid #ccc", width: "92%" }} required />
            <button type="button" onClick={() => setShowCurr((v) => !v)} style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src={showCurr ? passwordRevealed : passwordNotRevealed} alt={showCurr ? "Hide password" : "Show password"} style={iconStyle} />
            </button>
          </div>

          <div style={{ position: "relative" }}>
            <input name="newPassword" type={showNew ? "text" : "password"} placeholder="New Password" value={form.newPassword} onChange={handleChange} style={{ padding: 12, fontSize: 16, borderRadius: 4, border: "1px solid #ccc", width: "92%" }} required />
            <button type="button" onClick={() => setShowNew((v) => !v)} style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src={showNew ? passwordRevealed : passwordNotRevealed} alt={showNew ? "Hide password" : "Show password"} style={iconStyle} />
            </button>
          </div>

          <div style={{ fontSize: 13, color: "#555", marginTop: -10, marginBottom: -10 }}>
            <div style={{ display: "flex", alignItems: "center" }}>{criteria.length ? <span style={checkStyle}>✓</span> : <span style={crossStyle}>✗</span>} At least 12 characters</div>
            <div style={{ display: "flex", alignItems: "center" }}>{criteria.upper ? <span style={checkStyle}>✓</span> : <span style={crossStyle}>✗</span>} Uppercase letter</div>
            <div style={{ display: "flex", alignItems: "center" }}>{criteria.lower ? <span style={checkStyle}>✓</span> : <span style={crossStyle}>✗</span>} Lowercase letter</div>
            <div style={{ display: "flex", alignItems: "center" }}>{criteria.number ? <span style={checkStyle}>✓</span> : <span style={crossStyle}>✗</span>} Number</div>
            <div style={{ display: "flex", alignItems: "center" }}>{criteria.special ? <span style={checkStyle}>✓</span> : <span style={crossStyle}>✗</span>} Special character</div>
          </div>

          <div style={{ position: "relative" }}>
            <input name="confirmNew" type={showConfirm ? "text" : "password"} placeholder="Confirm New Password" value={form.confirmNew} onChange={handleChange} style={{ padding: 12, fontSize: 16, borderRadius: 4, border: "1px solid #ccc", width: "92%" }} required />
            <button type="button" onClick={() => setShowConfirm((v) => !v)} style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src={showConfirm ? passwordRevealed : passwordNotRevealed} alt={showConfirm ? "Hide password" : "Show password"} style={iconStyle} />
            </button>
          </div>

          {form.confirmNew.length > 0 && (
            <div style={{ marginTop: 4, fontSize: 14, fontWeight: 500, color: form.newPassword === form.confirmNew ? "#22c55e" : "#ef4444", minHeight: 20 }} aria-live="polite">
              {form.newPassword === form.confirmNew ? "Passwords match!" : "Passwords do not match"}
            </div>
          )}

          <button type="submit" disabled={submitting} style={{ width: "100%", padding: "16px 0", fontSize: 20, background: "#2563eb", color: "#fff", border: "none", cursor: "pointer", transition: "background 0.2s" }}>
            {submitting ? "Updating..." : "Update Password"}
          </button>
          {error && <div style={{ color: "red" }}>{error}</div>}
          {success && <div style={{ color: "green" }}>{success}</div>}
        </form>
      </div>
    </div>
  );
}
